export const KEY_CODE = {
    BACKSPACE_KEY: 8,
    LEFT_ARROW_KEY: 37,
    UP_ARROW_KEY: 38,
    RIGHT_ARROW_KEY: 39,
    DOWN_ARROW_KEY: 40,
    E_KEY: 69,
    DELETE_KEY: 46,
    ESC_KEY: 27,
    TAB_KEY: 9,
    ENTER_KEY: 13,
}

export const INDEX_KEY = {
    PRICE: 1,
    QTY: 2,
    ORDER_TYPE: 4,
    GTD: 8,
    STOP_PRICE: 16,
    AMOUNT:32,
    UNIT:64
}